import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/ai/SmartGenerate/list", {
        params: {
            ...params
        }
    } )
}

function GET_SEACH(params) {
    return axios.get("/ai/SmartGenerate/selects", {
        params: {
            ...params
        }
    } )
}


function EDIT_DATA(params) {
    return  axios.post("/ai/SmartGenerate/info",
      {id:params}
      )
}

function SUBMIT_EDIT(params) {
    return  axios.post("/ai/SmartGenerate/edit",{...params} )
}

export default {
    GET_LIST,
    EDIT_DATA,
    SUBMIT_EDIT,
    GET_SEACH
}